import common from './common';

export default {
  ...common,
  featureFlagEndpoint: 'https://sdx.qa.xfinity.com/cms/data/myAccount/web/staging/featureFlagsStaging.json',
  firebaseConfig: {
    ...common.firebaseConfig,
    appId: '1:81318095329:web:927f20baf4e80dda180aa0',
  },
};
